export const setSkickyAdvTop = (): void => {
  const DATA_STATE_SECTION_TABS = 'hasSectionTabs';
  const $advList = document.querySelectorAll('.u-sticky');

  $advList.forEach((advContainer) => {
    advContainer.setAttribute('data-state', DATA_STATE_SECTION_TABS);
  });
};
